import WebRequest from './client/WebRequest.js';
export async function uploadSupportingDocument(client, presignedGenUrl, { document, updateProgress, creationToken }, adapter) {
    const { bytes } = await adapter.read(document);
    const sha256 = await adapter.sha256Base64(bytes);
    const body = {
        name: document.name,
        length: bytes.byteLength,
        type: document.type,
        sha256,
        creationToken: creationToken ?? null,
    };
    const result = await client.execute(WebRequest.POST(presignedGenUrl).body(body));
    await adapter.put({
        url: result.url,
        contentType: document.type,
        checksumSha256Base64: sha256,
        document,
        bytes,
        updateProgress,
    });
    return result;
}
